import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Stack } from "@mui/material";
import { ArchiveActionButton, UnarchiveActionButton } from "../../../components/buttons";
import { InitialNameAvatar } from "../../../components/images/initial-name-avatar";
import { SimpleTable } from "../../../components/mui/table";
import { ENUM_USER_ROLES, RENDERER_TYPES } from "../../../enums";
import { convertToFullName } from "../../../services/utils";
import { tableStyles } from "./styles";

function UsersListTable({
  list,
  columns,
  handlePageFilters,
  appliedFilters,
  onArchiveClick,
  onUnarchiveClick,
  onDeleteClick,
  listView,
}: any) {
  const { selectedPage, selectedPageSize } = appliedFilters;

  const handleTDRenderer = (row, column) => {
    switch (column.rendererType) {
      case RENDERER_TYPES.FULL_NAME_WITH_AVATAR:
        return (
          <InitialNameAvatar
            text={convertToFullName(row.firstName, row.lastName)}
            name={row.firstName}
          />
        );
      case RENDERER_TYPES.ACTION:
        if (row?.role === ENUM_USER_ROLES.SUPER_ADMIN) return null;
        return (
          <Stack gap={1} direction="row" justifyContent="flex-end">
            {listView === "archived" ? (
              <>
                <UnarchiveActionButton onClick={() => onUnarchiveClick(row.id)} />
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<DeleteIcon fontSize="small" sx={tableStyles.deleteIcon} />}
                  onClick={() => onDeleteClick(row.id)}
                  sx={{ ...tableStyles.actionButton, ...tableStyles.deleteButton }}
                >
                  Delete
                </Button>
              </>
            ) : (
              <ArchiveActionButton onClick={() => onArchiveClick(row.id)} />
            )}
          </Stack>
        );
      default:
        return row?.[column.field] || "-";
    }
  };

  return (
    <SimpleTable
      tdRenderer={handleTDRenderer}
      rows={list?.data}
      fetching={list?.loading}
      columns={columns}
      total={list?.total}
      onPageSettingsChange={handlePageFilters}
      selectedPage={selectedPage}
      selectedPageSize={selectedPageSize}
    />
  );
}

export { UsersListTable };
